import React from "react";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Content } from "./content";

interface PageLayoutProps {
  content: React.ReactNode;
  rightSidebar: React.ReactNode;
}

export function PageLayout(props: PageLayoutProps) {
  const { content, rightSidebar } = props;

  const { locale } = useI18n();

  return (
    <Content>
      <div className="page-layout">
        <div className="page-layout-content">{content}</div>
        <div
          style={{
            ...(locale.direction === "ltr"
              ? { paddingRight: 16 }
              : { paddingLeft: 16 }),
          }}
          className="page-layout-sidebar"
        >
          {rightSidebar}
        </div>
      </div>
    </Content>
  );
}
